<template>
  <RevDrawer :name :title="i18n(translations.modalName)">
    <template #body>
      <div class="space-y-24">
        <RevIllustration
          alt="BackUpPlus Header"
          class="w-full"
          :height="150"
          src="/img/insurance/backupPlusModalHeader.png"
          :width="330"
        />

        <BenefitsTable>
          <template #firstColumnTitle>
            <RevIllustration
              alt="BackUpPlus logo"
              class="inline-block align-middle"
              :height="27"
              src="/img/insurance/backUpPlusLogo.svg"
              :width="80"
            />
          </template>
          <template #secondColumnTitle>
            <div class="text-static-default-hi body-1">
              {{ i18n(translations.warranty) }}
            </div>
          </template>

          <template #rows>
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="true"
              :title="i18n(translations.comparisonTable1)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable2)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable3)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable4)"
            />
          </template>
        </BenefitsTable>

        <section class="space-y-8">
          <header>
            <h2 class="text-static-default-hi heading-3">
              {{ i18n(translations.howToUseBackupPlus) }}
            </h2>
          </header>
          <div class="bg-static-default-low rounded-lg space-y-16 p-24">
            <InsurancePremiumDetails
              :icon="IconClock"
              :title="i18n(translations.howToUseBackupPlusTitle1)"
            >
              {{ i18n(translations.howToUseBackupPlusContent1) }}
            </InsurancePremiumDetails>
            <InsurancePremiumDetails
              :icon="IconHeadset"
              :title="i18n(translations.howToUseBackupPlusTitle2)"
            >
              {{ i18n(translations.howToUseBackupPlusContent2) }}
            </InsurancePremiumDetails>
            <InsurancePremiumDetails
              :icon="IconTools"
              :title="i18n(translations.howToUseBackupPlusTitle3)"
            >
              {{ i18n(translations.howToUseBackupPlusContent3) }}
            </InsurancePremiumDetails>
            <InsurancePremiumDetails
              :icon="IconCycle"
              :title="i18n(translations.howToUseBackupPlusTitle4)"
            >
              {{ i18n(translations.howToUseBackupPlusContent4) }}
            </InsurancePremiumDetails>
          </div>
        </section>

        <InsurancePremiumDrawerFaq />
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { IconClock } from '@ds/icons/IconClock'
import { IconCycle } from '@ds/icons/IconCycle'
import { IconHeadset } from '@ds/icons/IconHeadset'
import { IconTools } from '@ds/icons/IconTools'

import BenefitRow from '../components/BenefitRow/BenefitRow.vue'
import BenefitsTable from '../components/BenefitsTable/BenefitsTable.vue'

import translations from './InsurancePremiumDrawer.translations'
import InsurancePremiumDetails from './components/InsurancePremiumDetails/InsurancePremiumDetails.vue'
import InsurancePremiumDrawerFaq from './components/InsurancePremiumDrawerFaq/InsurancePremiumDrawerFaq.vue'

defineProps<{ name: string }>()

const i18n = useI18n()
</script>
